import React from "react";

export default function InvestmentCard({ title, description, onClick }) {
  return (
    <div
      onClick={onClick}
      className="cursor-pointer bg-white border rounded-xl p-5 shadow-sm hover:shadow-md transition duration-200"
    >
      <h3 className="text-lg font-semibold text-gray-800 mb-2">{title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed">
        {description || "No description available."}
      </p>
    </div>
  );
}
